"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Grid_1 = require("@material-ui/core/Grid");
const styles_1 = require("@material-ui/core/styles");
const ArcadeCard_1 = require("../card/ArcadeCard");
const styles = (theme) => (0, styles_1.createStyles)({
    arcadeContainer: {
        padding: 19,
        border: `1px solid ${theme.palette.secondary.main}`,
        background: 'rgba(0,0,0,0.5)',
        borderRadius: 8,
        boxShadow: `0 1px 2px 0 ${theme.palette.secondary.main}`
    }
});
const ArcadeCardContainer = ({ games, onPress }) => ((0, jsx_runtime_1.jsx)(Grid_1.default, Object.assign({ container: true, spacing: 3 }, { children: games.map(game => ((0, jsx_runtime_1.jsx)(Grid_1.default, Object.assign({ item: true, xs: 12, sm: 12, md: 6, lg: 3 }, { children: (0, jsx_runtime_1.jsx)(ArcadeCard_1.default, { game: game, onPress: onPress }) }), game.id))) })));
exports.default = (0, styles_1.withStyles)(styles)(ArcadeCardContainer);
//# sourceMappingURL=ArcadeCardContainer.js.map